// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2ngrX","label":"Section_label__3Hjtp","contentWrap":"Section_contentWrap__3JuUG","footer":"Section_footer__1mJB-","footerInner":"Section_footerInner__2eX1X"};